import { Component, OnInit } from '@angular/core';
import {GoBaseComponent} from "../go-base.component";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {VALUE_TYPE} from "../../../enums/enums";

@Component({
  selector: 'app-go-periodical-reward',
  templateUrl: './go-periodical-reward.component.html',
  styles: []
})

export class GoPeriodicalRewardComponent extends GoBaseComponent{

  GO_COMPONENTS = GO_COMPONENTS;
  VAL_TYPES = VALUE_TYPE;

  constructor() {
    super(GO_COMPONENTS.PERIODICAL_REWARD)
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-periodical-reward/go-periodical-reward.component.ts